module.exports = __webpack_public_path__ + "static/Felis-W3-7719d2e6a9e80a0e22684f820eae347a.pdf";